import { css, styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const CheckboxContainer = styled.div<{
  $columns?: number;
  $large?: boolean;
  $hasError?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    props.$large &&
    css`
      margin: 0 -6px;
    `};
  justify-content: flex-start;
  border-radius: 8px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    flex-direction: row;
  }
  ${(props) =>
    props.$hasError &&
    css`
      border: solid 1px ${colors.alertRed};
      box-shadow: 0 0 0 1px ${colors.alertRed};
      padding-right: 15px;
      padding-left: 15px;
    `};
`;
